module.exports = __webpack_public_path__ + "img/blimpy8.bb5b68a0.jpg";